import React, { CSSProperties, ChangeEvent, useState, useEffect } from 'react'
import InputComponent from '../Input/InputComponent'
import shortId from 'shortid';

import './InputFileComponent.scss'
import { AiFillCamera } from 'react-icons/ai';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import { FieldValues, UseFormMethods } from 'react-hook-form';
import { TypeFormatsAttachedCategory } from 'app_types/admin/attachedCategory/attachedCategory.types';
import LabelComponent from '../LabelComponent/LabelComponent';

interface IInputFileComponentProps {
    as: 'file' | 'image'
    className?: string
    style?: CSSProperties
    value?: string
    name?: string
    ref?: any
    message?: string,
    // formHook?: any
    formHook?: UseFormMethods<FieldValues>
    disabled?: boolean
    required?: boolean
    valid?: boolean
    validText?: string
    invalid?: boolean
    invalidText?: string
    label?: string
    defaultUrl?: string
    limitSizeKB?: number
    errorSize?: string
    accept?: string
    extensions?: TypeFormatsAttachedCategory[]
    onChange?: (e: ChangeEvent<HTMLInputElement>)=>any
    onEnter?: (value?: string)=>any
    onValidateExtension?: (isValid: boolean) => void
}

const expressionsToValidate = {
  xlsx: new RegExp(/(\.xlsx)/gi),
  png: new RegExp(/(\.png)/gi),
  jpg: new RegExp(/(\.jpg)/gi),
  gif: new RegExp(/(\.gif)/gi),
  pdf: new RegExp(/(\.pdf)/gi),
  ppt: new RegExp(/(\.ppt)/gi),
  docx: new RegExp(/(\.docx)/gi),
}

const InputFileComponent: React.FC<IInputFileComponentProps> = (props) => {

    const [file, updateFile] = useState<File | undefined>(undefined)
    const [urlFile, updateUrlFile] = useState<string | undefined>(props.defaultUrl ? props.defaultUrl : '')
    const [idFile, updateIdFile] = useState<string | undefined>(undefined)
    const [showErrorSize, updateShowErrorSize] = useState<boolean>(false)
    const [showErrorExtension, updateShowErrorExtension] = useState<boolean>(false)

    const { onValidateExtension } = props

    useEffect(() => {
        updateIdFile(shortId.generate())
    },[])

    useEffect(() => {
        if(!props.value) return
        if(typeof props.value === 'string'){
            updateUrlFile(props.value)
            updateFile(undefined)
        }
    },[props.value])

    useEffect(() => {
      if (onValidateExtension) {
        onValidateExtension(!showErrorExtension)
      }
    }, [onValidateExtension, showErrorExtension])

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if(e.target.files?.length){
            const file = e.target.files[0]
            const url = URL.createObjectURL(file)
            updateFile(file)
            updateUrlFile(url)
            // @INFO Validar el tamaño del archivo
            validateSizeFile(e.target.files);
            // @INFO Validar las extensiones
            validateExtensions(e.target.files);
            // @INFO Enviar el onChange
            if(props.onChange){
                props.onChange(e)
            }
        }
    }

    const validateSizeFile = (files: FileList) => {
      const file = files[0];
      if (file && props.limitSizeKB !== undefined && (file.size > (props.limitSizeKB*1000))) {
        updateShowErrorSize(true);
        return false;
      }
      updateShowErrorSize(false);
      return true;
    }

    const validateExtensions = (files: FileList) => {
      const file = files[0];
      if (file && props.extensions?.length) {
        const name = file.name;
        const extension = name.split('.')[1];
        const valid = props.extensions.reduce((accum, item) => {
          const aux = extension === item;
          // const aux = expressionsToValidate[item].test(name);
          if (!accum && aux) {
            accum = true;
          }
          return accum;
        }, false);
        updateShowErrorExtension(!valid);
        return valid;
      } else {
        updateShowErrorExtension(false);
        return true;
      }
    }

    const getInputMessage = () => {
      return props.message || `Sube un archivo`
    }

    return(
        <div
            className={`input_file_component-layout ${props.className ? props.className : ''}`}
            style={props.style}
        >
            <InputComponent
                name={props.name}
                ref={props.ref}
                formHook={ props.formHook ? props.formHook.register({ validate: { validateExtensions, validateSizeFile }, required: props.required }) : undefined}
                disabled={props.disabled}
                required={props.required}
                valid={props.valid}
                validText={props.validText}
                invalid={props.invalid}
                invalidText={props.invalidText}
                label={props.label}
                type='file'
                id={idFile}
                accept={props.accept}
                className={`${props.as === 'image' ? 'hide-input-file-component' : ''}`}
                onChange={handleChange}
                onEnter={props.onEnter}
            >
                {props.as === 'image' && idFile ?
                  <>
                      <label htmlFor={idFile}>
                          <div
                              className="container-image-input-file_component"
                              style={{ backgroundImage: urlFile ? `url(${urlFile})` : undefined }}
                          >
                              {!urlFile ?
                                  <TextComponent
                                    type='text'
                                    style={{ color: 'white', fontWeight: 600, fontSize: '1rem' }}
                                    className='text-explication-upload-file'
                                  >

                                    {getInputMessage()}

                                  </TextComponent>
                              : null}
                              <div className="on-hover-input-image">
                                  <AiFillCamera/>
                              </div>
                          </div>
                      </label>
                  </>
                :null}
            </InputComponent>
            {props.as !== 'image' && urlFile ? (
              <a href={urlFile} target="_blank" rel="noreferrer">
                <LabelComponent color="var(--secondary)" marginTop="10px">
                  {urlFile}
                </LabelComponent>
              </a>
            ) : null}
            {showErrorSize ?
              <div style={{display: 'initial'}} className="invalid-feedback">
                  {props.errorSize ? props.errorSize : `El peso máximo es de ${props.limitSizeKB}KB.`}
              </div>
            : null}
            {showErrorExtension && props.extensions?.length ?
              <div style={{display: 'initial'}} className="invalid-feedback">
                  {props.errorSize ? props.errorSize : ` Los formatos permitidos son ${props.extensions.join(', ')}.`}
              </div>
            : null}
        </div>
    );
}

export default InputFileComponent;
